import { useState } from "react";
import {
    Burger, MobileMenu, Navbar, NavItem, NavLinks, NavLogo, NavWrapper, FacebookIcon, InstagramIcon, NavIcons, LangSwitch, LangBtn, CenterFlex, HomeIconSvg, NavRouterItem, NavRight,
} from "./styled";
import { Link } from "react-scroll";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LINKS } from "../../config/links";

const NavigationBar = ({ variant = "default" }) => {
    const [isOpen, setIsOpen] = useState(false);
    const { t, i18n } = useTranslation(["common", "policy"]);

    const navItems = [
        { key: "home", to: "home", href: "#home", desktopOffset: -90, mobileOffset: -50 },
        { key: "services", to: "services", href: "#services", desktopOffset: -90, mobileOffset: -50 },
        { key: "cruises", to: "cruises", href: "#cruises", desktopOffset: -90, mobileOffset: -50 },
        { key: "houses", to: "houses", href: "#houses", desktopOffset: -90, mobileOffset: -50 },
        { key: "bikes", to: "bikes", href: "#bikes", desktopOffset: -90, mobileOffset: -50 },
        { key: "contact", to: "address", href: "#address", desktopOffset: -90, mobileOffset: -50 },
        { key: "partners", to: "partners", href: "#partners", desktopOffset: -90, mobileOffset: -50 },
    ];

    const setLang = (lng) => {
        i18n.changeLanguage(lng);
        setIsOpen(false);
    };

    const current = i18n.resolvedLanguage || i18n.language;

    return (
        <header>
            <Navbar>
                <NavWrapper>
                    {variant === "policy" ? (
                        <RouterLink to="/" aria-label="Czorsztynianka – strona główna">
                            <NavLogo aria-hidden="true" focusable="false" />
                        </RouterLink>
                    ) : (
                        <Link to="home" href="#home" smooth duration={600} offset={-90}>
                            <NavLogo aria-hidden="true" focusable="false" />
                        </Link>
                    )}

                    {variant !== "policy" && (
                        <NavLinks>
                            {navItems.map((item) => (
                                <NavItem
                                    key={item.key}
                                    to={item.to}
                                    href={item.href}
                                    smooth
                                    duration={600}
                                    offset={item.desktopOffset}
                                >
                                    {t(`nav.${item.key}`)}
                                </NavItem>
                            ))}
                        </NavLinks>
                    )}

                    {variant === "policy" && (
                        <NavLinks>
                            <NavRouterItem to="/" onClick={() => setIsOpen(false)}>
                                <CenterFlex>
                                    <HomeIconSvg />
                                    {t("backHome", { ns: "policy" })}
                                </CenterFlex>
                            </NavRouterItem>
                        </NavLinks>
                    )}
                    <NavRight>

                        <LangSwitch>
                            <LangBtn
                                type="button"
                                $active={current?.startsWith("pl")}
                                onClick={() => setLang("pl")}
                                aria-label="Switch language to Polish"
                                title="Polski"
                            >
                                PL
                            </LangBtn>
                            <LangBtn
                                type="button"
                                $active={current?.startsWith("en")}
                                onClick={() => setLang("en")}
                                aria-label="Switch language to English"
                                title="English"
                            >
                                EN
                            </LangBtn>
                        </LangSwitch>
                        <NavIcons>
                            <a href={LINKS.facebook} target="_blank" aria-label="Facebook" rel="noreferrer">
                                <FacebookIcon />
                            </a>
                            <a href={LINKS.instagram} target="_blank" aria-label="Instagram" rel="noreferrer">
                                <InstagramIcon />
                            </a>
                        </NavIcons>
                        <Burger
                            $open={isOpen}
                            onClick={() => setIsOpen((v) => !v)}
                            aria-label={isOpen ? "Zamknij menu" : "Otwórz menu"}
                            aria-expanded={isOpen}
                            aria-controls="mobile-menu"
                        >
                            <span />
                            <span />
                            <span />
                        </Burger>
                    </NavRight>

                    <MobileMenu id="mobile-menu" $open={isOpen}>
                        {variant !== "policy" &&
                            navItems.map((item) => (
                                <NavItem
                                    key={`mobile-${item.key}`}
                                    to={item.to}
                                    href={item.href}
                                    smooth
                                    duration={600}
                                    offset={item.mobileOffset}
                                    onClick={() => setIsOpen(false)}
                                >
                                    {t(`nav.${item.key}`)}
                                </NavItem>
                            ))}
                        {variant === "policy" && (
                            <NavRouterItem to="/" onClick={() => setIsOpen(false)}>
                                <CenterFlex>
                                    <HomeIconSvg />
                                    {t("backHome", { ns: "policy" })}
                                </CenterFlex>
                            </NavRouterItem>
                        )}
                    </MobileMenu>
                </NavWrapper>
            </Navbar>
        </header>
    );
};

export default NavigationBar;